import { PeriodItemContainer } from "./Period.styled";
import { PricingActualTypePeriod } from "../../../interfaces";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";

interface PeriodItemProps {
	isActive: boolean;
	name: PricingActualTypePeriod;
	title: string;
	value: number;
}

export const PeriodItem = observer(({ isActive, name, title, value }: PeriodItemProps) => {
	const { pricingActualStore } = useStores();

	const handleOnChangePeriod = () => {
		pricingActualStore.changeTypePeriod(name);
		pricingActualStore.setPeriodId(value);
	};

	return (
		<PeriodItemContainer isActive={isActive} onClick={handleOnChangePeriod}>
			{title}
		</PeriodItemContainer>
	);
});
